import { CustomPlanContext } from 'src/pages/superAdmin/modals/CustomPlan/context/context'
import { CustomPlanUi } from 'src/pages/superAdmin/modals/CustomPlan/ui/CustomPlanUi'
import { CustomPlanStore } from 'src/pages/superAdmin/modals/CustomPlan/store/CustomPlanStore'

export const CustomPlan = ({ store }: { store: CustomPlanStore }) => (
  <CustomPlanContext.Provider value={store}>
    <CustomPlanUi />
  </CustomPlanContext.Provider>
)
